export class SignalRFileTransfer {
    constructor(connection, clientId) {
        this.connection = connection;
        this.clientId = clientId;
    }
    sendBundle(bundle, dirtyOnly, toClientId) {
        if (bundle.modules.length !== bundle.modulesMeta.length)
            throw `The module meta data length does not match the number of modules in the application bundle.`;
        // Send modules one by one, since SignalR isn't designed to transfer large messages.
        // Trick for sequentially resolving promises
        return bundle.modulesMeta.reduce((accumulatorPromise, meta, i) => {
            return accumulatorPromise.then(() => {
                if (dirtyOnly && !meta.isDirty)
                    return accumulatorPromise;
                const module = bundle.modules[i];
                return this.sendModule(meta, module, toClientId);
            });
        }, Promise.resolve());
    }
    sendModule(meta, module, toClientId) {
        if (module.size > 32000) {
            console.warn(`Size of module '${meta.fileInfo.name}' is larger than the default SignalR buffer size of 32KB. Actual size: ${module.size} bytes. Server errors may occur.`);
        }
        // Load the module as text (we cannot send Blobs)
        return SignalRFileTransfer
            .blobToText(module)
            .then((textContents) => {
            const message = {
                type: 12 /* SignalingMessageType.PreviewModule */,
                metaData: meta,
                contents: textContents,
                fromClientId: this.clientId,
                toClientId: toClientId,
            };
            return message;
        })
            .then((message) => {
            return this.connection
                .invoke('ReceiveClientPreviewModuleMessage', message)
                .catch(reason => console.error("SignalR ReceivePreviewModuleMessage error", reason));
        });
    }
    receiveBundle(manifest, expectedModuleCount) {
        const modules = [];
        const modulesMeta = [];
        let moduleCount = 0;
        // Wait until all modules are read, then resolve.
        return new Promise((resolve, reject) => {
            this.connection.on('ReceiveServerPreviewModule', (message) => {
                moduleCount++;
                modulesMeta.push(message.metaData);
                modules.push(new Blob([message.contents]));
                if (moduleCount !== expectedModuleCount)
                    return;
                // Done...
                this.connection.off('ReceiveServerPreviewModule');
                const bundle = {
                    manifest: manifest,
                    modules: modules,
                    modulesMeta: modulesMeta
                };
                resolve(bundle);
            });
        });
    }
    //#region utilities
    static blobToText(blob) {
        var reader = new FileReader();
        return new Promise((resolve, reject) => {
            reader.onload = (e) => {
                const src = e.srcElement.result;
                resolve(src);
            };
            reader.onerror = (e) => {
                reject(e);
            };
            reader.readAsText(blob);
        });
    }
}
//# sourceMappingURL=signalr-file-transfer.js.map